import { actionTypes } from './actionTypes';

export const toggleDrawer = () => {
  return {
    type: actionTypes.TOGGLE_DRAWER,
  };
};

export const toggleDeleteModal = () => {
  return {
    type: actionTypes.TOGGLE_DELETE_MODAL,
  };
};

export const setDrawerTitle = (drawerTitle) => {
  return {
    type: actionTypes.SET_DRAWER_TITLE,
    drawerTitle,
  };
};

export const setRole = (role) => {
  return {
    type: actionTypes.SET_ROLE,
    role,
  };
};

export const setRoleList = (roleList) => {
  return {
    type: actionTypes.SET_ROLE_LIST,
    roleList,
  };
};

export const optimisticallyUpdateRoleList = (role) => {
  return {
    type: actionTypes.OPTIMISTICALLY_UPDATE_ROLE_LIST,
    role,
  };
};

export const optimisticallyDeleteRole = (role) => {
  return {
    type: actionTypes.OPTIMISTICALLY_DELETE_ROLE,
    role,
  };
};

export const setIsLoading = (isLoading) => {
  return {
    type: actionTypes.SET_IS_LOADING,
    isLoading,
  };
};

export const setTabMacros = (tabsMacros) => {
  return {
    type: actionTypes.SET_TABS_MACROS,
    tabsMacros,
  };
};

export const setCustomPermissions = (customPermissions) => {
  return {
    type: actionTypes.SET_CUSTOM_PERMISSIONS,
    customPermissions,
  };
};

export const setInitialPermissions = (initialPermissions) => {
  return {
    type: actionTypes.SET_INITIAL_PERMISSIONS,
    initialPermissions,
  };
};

export const setRoleRequestBody = (permissions) => {
  return {
    type: actionTypes.SET_ROLE_REQUEST_BODY,
    permissions,
  };
};

export const setEditPermissions = (macroSettings) => {
  return {
    type: actionTypes.SET_EDIT_PERMISSIONS,
    macroSettings,
  };
};

export const updateEditPermissions = (roles) => {
  return {
    type: actionTypes.UPDATE_EDIT_PERMISSIONS,
    roles,
  };
};

export const setIsLoadingRole = (isLoadingRole) => {
  return {
    type: actionTypes.SET_IS_LOADING_ROLE,
    isLoadingRole,
  };
};

export const updateRoleRequestBody = (permission) => {
  return {
    type: actionTypes.UPDATE_ROLE_REQUEST_BODY,
    permission,
  };
};

export const updateRoleRequestBodyName = (name) => {
  return {
    type: actionTypes.UPDATE_ROLE_REQUEST_BODY_NAME,
    name,
  };
};

export const setRoleNameError = (error) => {
  return {
    type: actionTypes.SET_ROLE_NAME_ERROR,
    error,
  };
};
